import React from 'react';
import { Outlet, useLocation } from 'react-router-dom'; // استيراد Outlet و useLocation
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types/user'; // تأكد من استيراد UserRole
// 1. استيراد المكونات الناقصة
import Header from './Header';
import Sidebar from './Sidebar';
import LawyerSidebar from './LawyerSidebar';

// 2. استيراد الـ hooks والأنماط
import { useApp } from '../../contexts/AppContext';
import styles from './Layout.module.css';

// 3. تعريف الواجهة الناقصة (يمكنك وضعها في ملف types إذا أردت)
interface LayoutProps {
  children?: React.ReactNode; // جعل children اختيارياً لأننا سنستخدم Outlet
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isSidebarOpen, toggleSidebar } = useApp();
  const location = useLocation();
  const { user } = useAuth();
  // 4. تعريف المتغير الناقص 'currentTitle'
  // دالة بسيطة لتحديد العنوان من المسار
  const getTitleFromPath = (path: string): string => {
    if (path.startsWith('/lawyers')) return 'إدارة المحامين';
    if (path.startsWith('/invoices')) return 'إدارة الفواتير';
    if (path.startsWith('/complaints')) return 'إدارة الشكاوى';
    if (path.startsWith('/profile')) return 'الملف الشخصي';
    return 'لوحة التحكم الرئيسية';
  };

  const currentTitle = getTitleFromPath(location.pathname);
  const renderSidebar = () => {
    if (!user) return null; // لا تعرض أي سايدبار إذا لم يكن هناك مستخدم

    switch (user.role) {
      case UserRole.ADMIN:
        return <Sidebar />;
      case UserRole.LAWYER:
        return <LawyerSidebar />;
      // case UserRole.SUBSCRIBER:
      //   return <SubscriberSidebar />;
      // أضف حالات أخرى حسب الحاجة
      default:
        // يمكنك عرض سايدبار افتراضي أو لا شيء
        return null; 
    }
  };

  return (
    <div className={styles.layoutContainer}>
      <div 
        className={`${styles.overlay} ${isSidebarOpen ? styles.visible : ''}`} 
        onClick={toggleSidebar}
      ></div>
      
      {/* الآن هذه المكونات معرفة */}
       {renderSidebar()}

      <main className={styles.mainContent}>
        <Header title={currentTitle} />
        <div className={styles.pageContent}>
          {/* استخدام Outlet هو الممارسة الأفضل لعرض محتوى الصفحات الفرعية */}
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
